import axios from 'axios'
import constants from '../lib/constants'

// CONSTANTS
export const GET_CLAIMS_JOBS = 'GET_CLAIMS_JOBS'
export const GET_CLAIMS_JOBS_COMPLETE = 'GET_CLAIMS_JOBS_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getClaimsJobs = (siteId, fromDate, toDate) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_CLAIMS_JOBS })
    return axios.get(`${constants.API_URL}/tooling/claims/jobs_for_site`,
      {
        params: {
          site_id: siteId,
          from_date: fromDate,
          to_date: toDate
        }
      })
    .then((response) => {
      const patients = response.data
      dispatch({
        type    : GET_CLAIMS_JOBS_COMPLETE,
        payload : {
          patients_with_jobs: patients,
        }
      })
      return response
    })
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_CLAIMS_JOBS_COMPLETE] : (state, action) => {
    const { patients_with_jobs } = action.payload
    const newState = {
      ...state,
      patients_with_jobs
    }
    return newState
  }
}

// REDUCER

const initialState = {
  sites: [],
  createdSite: null,
}

export default function sitesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/tooling.js